
























































































import {Component, PropSync, Watch} from 'vue-property-decorator'
import {Getter, Action} from "vuex-class";
import {SelectWings, ToggleWings, InputWings} from "wings-ui-components";
import {OriginatorFilter} from "@/store/settings/originators/types";
import {notifyError} from "@/utils/notify-helper";
import BaseFilter from "@/components/Filter/BaseFilter";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings, ToggleWings, InputWings}})
export default class OriginatorsFilter extends BaseFilter<OriginatorFilter> {
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;
  @PropSync('show') is_show!: boolean;
  @Getter("transports") transportsList: any;
  @Getter("originatorStatusList") statusList: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("exportOriginators") actionExportOriginators: any;

  defaultFilter(): OriginatorFilter {
    return {
      query: undefined,
      partner: undefined,
      transport: undefined,
      status: undefined,
      description: undefined,
      page_number: 1
    }
  }

  get transportsForOriginatorsList() {
    return this.transportsList.filter((value: any) => value.name.toLowerCase() !== 'push'
        && value.name.toLowerCase() !== 'ussd')
  }

  partnersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async created() {
    this.actionGetTransports();
    this.filtered();
    this.scroll();

    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
  }

  export(): void {
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Export",
      action_status: "success",
      object_type: "Originator",
      addititional_info: getTranslatedParams(this.filter)
    }
    this.actionExportOriginators(this.filter).then(()=>{
      this.actionLog(this.logObject);
    }).catch((error: any) =>{
      this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error)
    })
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Originator",
        addititional_info: getTranslatedParams(this.filter)
      };
      const resp = await this.actionGetOriginators(this.filter);
      await this.actionLog(this.logObject);
      this.is_last = resp.length == 0;
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: OriginatorFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
